<template>
  <div class="header-nav">
    <nav>
      <ul class="head" >
        <li id="logo" @click="ToHome">
          <img class="img" src="~@/view/images/LOGO-1.png" alt="" />
        </li>
        <li>
          <router-link
            class="FristPage"
            :to="'/HomePage'"
            :active-class="'active'"
          >
            首页
          </router-link>
        </li>
        <li class="solutionWay">
          <router-link
            :to="redirectTo"
            class="FristPage"
            :active-class="'active'"
          >
            解决方案
          </router-link>
          <ul class="Pagination">
            <li>
              <router-link
                :to="'/solution2'"
                class="solutionPage"
                :active-class="'active1'"
                @click.native="doSomething(2)"
              >
                蜂享优印解决方案
              </router-link>
            </li>

            <li>
              <router-link
                :to="'/solution1'"
                class="solutionPage"
                :active-class="'active1'"
                @click.native="doSomething(1)"
              >
                印刷数字化工厂解决方案
              </router-link>
            </li>
            <li>
              <router-link
                :to="'/solution'"
                class="solutionPage"
                :active-class="'active1'"
                @click.native="doSomething(3)"
              >
                印刷管家服务解决方案
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link
            :to="'/academic'"
            class="FristPage"
            :active-class="'active'"
          >
            学习园地
          </router-link>
        </li>
        <li>
          <router-link
            :to="'/information'"
            class="FristPage"
            :active-class="'active'"
          >
            新闻资讯
          </router-link>
        </li>
        <li>
          <router-link
            :to="'/about'"
            class="FristPage"
            :active-class="'active'"
          >
            关于我们
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'header-nav',
  data() {
    return {
      redirectTo: '/solution',
    };
  },
  methods: {
    ToHome() {
      this.$router.replace('/HomePage');
    },
    doSomething(val){
      switch(val){
        case 3 :
          this.redirectTo = "/solution"
          break;
        case 2 :
          this.redirectTo = "/solution2"
          break;
        case 1 :
          this.redirectTo = "/solution1"
          break;
      }

    }
  },
};
</script>

<style lang="scss" scoped>
 .head {
  height: 70px;
  background: #1f232a;
  li {
    float: left;
    margin: 0px 10px;
    a {
      width: 120px;
      height: 70px;
      text-align: center;
      line-height: 70px;
      color: #ffffff;
      display: block;
      font-size: 18px;
      transition: all ease 0.3s;
    }
  }
  .FristPage:hover {
    color: #f7b515;
    border-bottom: 4px solid #f7b515;
    text-decoration: none;
  }
  #logo {
    margin: 18px 30px 0;
    img {
      width: 130px;
      cursor: pointer;
    }
  }
}
.FristPage {
  color: #ffffff;
}
.active {
  color: #f7b515 !important;
  border-bottom: 4px solid #f7b515;
  text-decoration: none;
}
.solutionWay {
  position: relative;
}
.Pagination {
  position: absolute;
  background: #ffffff;
  font-size: 12px;
  // z-index: 999999;
  display: none;
  .solutionPage {
    color: #1f232a;
  }
  li {
    a {
      display: block;
      width: 200px;
      height: 50px;
      font-size: 12px;
      line-height: 50px;
      // color: #1f232a;
      margin: 10px 0px;
    }
  }
}
.solutionWay:hover .Pagination{
  display: block;
  z-index: 999999;
}
.solutionPage:hover {
  color: #f7b515;
  border-bottom: 2px solid #f7b515;
  // display: block;
  // z-index: 999999;
}
.active1 {
  color: #f7b515;
  border-bottom: 2px solid #f7b515;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue